/** @module csi/heading/RefImageRemoveController */
define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/AttributeController",
	"csi/image/_base",
	"csi/model/image",
	"csi/reflection",
	"csi/widget/Tooltip",
	"csi/xml"
], function(declare, csi, AttributeController, image, {getImageLabeledKeys}, reflection, Tooltip, xml) {

	return declare(AttributeController, {
		/**
		 *  Display error if trying to remove default image that is also a labeled image
		 *  close tooltip on delete so deleted images wont be attached to other actions on tooltip
		 */
		process: function() {
			Tooltip.hide();

			if (this.keyContainer == reflection.DEFAULT_IMAGE_LABEL) {
				const imageContainer = this.getNode();
				const keyLabels = getImageLabeledKeys(imageContainer, this.keyContainer);
				if (keyLabels.length) {
					this.postProcess(false);
					return;
				}
			}

			this.inherited(arguments);
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: if key is default, then reset to next available image; if key is label, then reset to empty
			var cn = this.m_writer.changeNode(this.m_urlNode);
			if (type == xml.ATTR_REF) {
				cn.changeAttribute(id, xml.ATTR_REF, csi.EMPTY_URL);
				return;
			}

			var images = this.getNode()[id];
			var keyDefault = reflection.DEFAULT_IMAGE_LABEL;
			var keyNumber = image.getNumberedKey(images, images[this.keyContainer]);
			var keysRemove = [keyNumber];

			if (images[keyDefault] == images[keyNumber]) {
				// if removing default image, then set new default
				var key = image.getFirstKey(images, true);
				if (key) {
					// set to next numbered key
					this.newValue = images[key];
					cn.changeAttributeKeys(id, type, csi.objectNew(keyDefault, this.newValue));
				} else {
					// no more images, so remove default key as well
					keysRemove.push(keyDefault);
					this.newValue = csi.EMPTY_URL;
				}

				// if labeled image is also the default image, then need to refresh entire node
				if (this.keyContainer != keyDefault) {
					this.bRefreshNode = true;
				}
			}

			// if removing labeled image, then remove its key as well as numbered key
			if (this.keyContainer != keyDefault) {
				keysRemove.push(this.keyContainer);
			}

			cn.removeAttributeKeys(id, type, keysRemove);
			return cn;
		}
	});
});